export default __webpack_public_path__ + "3b273e3.png";